import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2, Search } from 'lucide-react';

export function MaintCardShell({ title, description, testId, count, riskCount, loading, onScan, children }) {
  const hasCount = count !== null && count !== undefined;
  return (
    <Card className="bg-white border-gray-100" data-testid={`${testId}-card`}>
      <CardContent className="p-5 space-y-3">
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div>
            <p className="text-sm font-semibold text-gray-800">{title}</p>
            <p className="text-xs text-gray-500 max-w-xl mt-0.5">{description}</p>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            {hasCount && (
              <span
                data-testid={`${testId}-count`}
                className={`text-xs font-bold px-2.5 py-1 rounded-full ${
                  riskCount > 0 ? 'bg-red-100 text-red-700' : count > 0 ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'
                }`}
              >
                {count}
              </span>
            )}
            <Button data-testid={`${testId}-scan-btn`} size="sm" variant="outline" onClick={onScan} disabled={loading} className="border-[#003366]/20 text-[#003366]">
              {loading ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : <Search className="w-3.5 h-3.5 mr-1.5" />}
              Scan
            </Button>
          </div>
        </div>
        {children}
      </CardContent>
    </Card>
  );
}

export default MaintCardShell;
